import { useTranslation } from 'react-i18next';

import { CheckboxField, type CheckboxFieldProps } from '../../fields/CheckboxField';
import type { ProjectTasksFormFilerValue } from '../lib/types';

type AssignedToMeFieldProps = Omit<CheckboxFieldProps<ProjectTasksFormFilerValue, 'isAssignedToMe'>, 'name' | 'label'>;
export const AssignedToMeField = (props: AssignedToMeFieldProps) => {
  const { t } = useTranslation();

  return <CheckboxField {...props} name='isAssignedToMe' label={t('assigned-to-me')} />;
};
